import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import PropTypes from 'prop-types';

import './CreatePlanModal.scss';

export default function CreatePlanModal({ visible, onCancel, onCreate, isLoading }) {
    const [strategyName, setStrategyName] = useState('');
    const [error, setError] = useState('');

    // Reset state when modal opens
    useEffect(() => {
        if (visible) {
            setStrategyName('');
            setError('');
        }
    }, [visible]);

    const handleInputChange = (e) => {
        const { value } = e.target;
        setStrategyName(value);

        // Clear error when user starts typing
        if (error) {
            setError('');
        }
    };

    const validateAndSubmit = () => {
        const trimmedName = strategyName.trim();

        // Validate empty name
        if (!trimmedName) {
            setError('Strategy name is required');
            return;
        }

        // Validate length
        if (trimmedName.length < 2) {
            setError('Strategy name must be at least 2 characters');
            return;
        }

        if (trimmedName.length > 100) {
            setError('Strategy name must be less than 100 characters');
            return;
        }

        // Call onCreate with the validated name
        onCreate(trimmedName);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !isLoading) {
            validateAndSubmit();
        }
    };

    const handleCancel = () => {
        setStrategyName('');
        setError('');
        onCancel();
    };

    return (
        <Modal
            title="Create New Trading Plan"
            open={visible}
            onOk={validateAndSubmit}
            onCancel={handleCancel}
            okText="Create"
            cancelText="Cancel"
            confirmLoading={isLoading}
            okButtonProps={{ disabled: isLoading }}
            cancelButtonProps={{ disabled: isLoading }}
            destroyOnClose
            className="create-plan-modal"
        >
            <div className="modal-content">
                <div className="form-group">
                    <label htmlFor="strategyName" className="form-label">
                        Strategy Name <span className="required">*</span>
                    </label>
                    <Input
                        id="strategyName"
                        placeholder='Enter strategy name (e.g., "5-Min ORB", "VWAP Reversal")'
                        value={strategyName}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        status={error ? 'error' : ''}
                        autoFocus
                        disabled={isLoading}
                        size="large"
                    />
                    {error && <div className="error-message">{error}</div>}
                </div>

                <div className="help-text">
                    Give your trading strategy a unique, descriptive name that helps you identify it
                    later.
                </div>
            </div>
        </Modal>
    );
}

CreatePlanModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

CreatePlanModal.defaultProps = {
    isLoading: false
};
